import { FC, useMemo } from 'react';
import { SampleScope, seed } from '../../../components/FrostedGate/SampleScope';
import { customFieldsListAtom } from '../../../services/state/AdminPanel/CustomFieldsStateJ';
import { kpiConfigAtom, kpiGroupsAtom } from '../../../services/state/KPIConfigState';
import { PREVIEW_KPI_CONFIGURATIONS, PREVIEW_KPI_FIELDS } from '../kpi-module.fixtures';
import { KpiCollectionConfigs } from './KpiCollectionConfigs';

// The KPI form dialog behind the editor also reads the groups and custom fields.
const SEEDS = [
  seed(kpiConfigAtom, PREVIEW_KPI_FIELDS),
  seed(kpiGroupsAtom, []),
  seed(customFieldsListAtom, []),
];

interface KpiCollectionConfigPreviewProps {
  name?: string;
  isNew?: boolean;
}

/** The live collection configuration over a sample configuration, while the module is frosted. */
export const KpiCollectionConfigPreview: FC<KpiCollectionConfigPreviewProps> = ({ name, isNew = false }) => {
  const initialConfiguration = useMemo(
    () =>
      isNew
        ? undefined
        : { ...PREVIEW_KPI_CONFIGURATIONS[0], name: name ?? PREVIEW_KPI_CONFIGURATIONS[0].name },
    [name, isNew]
  );

  return (
    <SampleScope seeds={SEEDS}>
      <KpiCollectionConfigs
        key={initialConfiguration?.name ?? 'new'}
        initialConfiguration={initialConfiguration}
      />
    </SampleScope>
  );
};
